<div class="checkout">
  <aura-divider [type]="'light'"></aura-divider>
  <section class="checkout__information">
    <span class="checkout__checkmark"></span>
    <div class="checkout__header">
      {{ content.header }}
      <br />
      {{ content.information }}
    </div>
  </section>
  <aura-divider [type]="'light'"></aura-divider>
  <section class="checkout__details">
    <div class="checkout__price">
      <span class="checkout__details-header">{{ content.price.title }}</span>
      <span>{{ content.price.subtitle }}</span>
    </div>
    <div class="checkout__total">
      <span class="checkout__details-header">{{ content.total.title }}</span>
      <span>{{ content.total.subtitle }}</span>
    </div>
  </section>
  <section class="checkout__action">
    <div>
      <button
        auraButton
        class="checkout__previous"
        data-testid="submit-button"
        [buttonSize]="'small'"
        [buttonColor]="'secondary'"
        [buttonOutlineColor]="'secondary'"
        [id]="content.previous.id"
        (click)="previousButton.emit()"
      >
        {{ content.previous.label }}
      </button>
    </div>
    <div class="checkout__event">
      <a
        class="checkout__link"
        auraLink
        [id]="content.alternate.id"
        [linkSize]="'medium'"
        [linkColor]="'primary'"
        [href]="content.alternate.url"
        (click)="returnToSkyClub.emit()"
      >
        {{ content.alternate.label }}
      </a>
      <button
        class="checkout__button"
        auraButton
        data-testid="submit-button"
        [buttonSize]="'small'"
        [buttonColor]="'primary'"
        [buttonOutlineColor]="'primary'"
        [id]="content.action.id"
        (click)="checkOut.emit()"
      >
        {{ content.action.label }}
      </button>
    </div>
  </section>
</div>
